import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue-demi';
import { AbButton } from '../../ui';
type Themes =
  | 'theme-cn'
  | 'theme-cng'
  | 'theme-ab'
  | 'theme-lrg'
  | 'theme-prsol'
  | 'theme-mdm'
  | 'theme-prsg'
  | 'theme-ar';
interface Props {
  variant?: string;
  size?: string;
  block?: boolean;
  inverted?: boolean;
  multilayered?: boolean;
  fitHeight?: boolean;
  minWidth?: string;
  icon?: string;
  disabled?: boolean;
  type?: string;
  target?: string;
  to?: string;
  effect?: 'glow';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    block: { type: Boolean, default: false },
    inverted: { type: Boolean, default: false },
    multilayered: { type: Boolean, default: false },
    fitHeight: { type: Boolean, default: false },
    minWidth: { default: 'auto' },
    icon: { default: undefined },
    disabled: { type: Boolean, default: false },
    type: { default: undefined },
    target: { default: undefined },
    to: { default: undefined },
    effect: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: string, size: string, block: boolean, inverted: boolean, multilayered: boolean, fitHeight: boolean, minWidth: string, icon: string, disabled: boolean, type: string, target: string, to: string, effect: 'glow' };



const buttonVariants: Partial<Record<Themes, any>> = {
  'theme-cn': {
    yellow: 'secondary',
    blue: 'tertiary',
    red: 'primary',
    aqua: 'cyan',
    pink: 'pink',
    gray: 'secondary',
  },
  'theme-ab': {
    yellow: 'secondary',
    blue: 'white',
    red: 'primary',
    aqua: 'white',
    pink: 'white',
    gray: 'secondary',
  },
  'theme-cng': {
    yellow: 'secondary',
    blue: 'outlined',
    red: 'primary',
    aqua: 'outlined',
    pink: 'outlined',
    gray: 'secondary',
  },
  'theme-lrg': {
    yellow: 'secondary',
    blue: 'primary',
    red: 'primary',
    aqua: 'primary',
    pink: 'primary',
    gray: 'secondary',
  },
  'theme-prsol': {
    yellow: 'secondary',
    blue: 'primary',
    red: 'primary',
    aqua: 'primary',
    pink: 'primary',
    gray: 'secondary',
  },
  'theme-prsg': {
    yellow: 'secondary',
    blue: 'primary',
    red: 'primary',
    aqua: 'primary',
    pink: 'primary',
    gray: 'secondary',
  },
  'theme-ar': {
    yellow: 'tertiary',
    blue: 'tertiary',
    red: 'tertiary',
    aqua: 'tertiary',
    pink: 'tertiary',
    gray: 'tertiary',
  },
};
const theme = ref<Themes>('theme-ab');
const currentVariant = computed(() => {
  if (buttonVariants[theme.value as Themes])
    return buttonVariants[theme.value as Themes][props.variant];
  return 'primary';
});

const clickEvent = () => {
  emit('click');
};

onMounted(() => {
  const themes: Themes[] = [
    'theme-cn',
    'theme-cng',
    'theme-ab',
    'theme-lrg',
    'theme-prsol',
    'theme-mdm',
    'theme-prsg',
    'theme-ar',
  ];
  themes.forEach((themeClass) => {
    if (document.querySelector(`.${themeClass}`)) theme.value = themeClass;
  });
});

return { __sfc: true,props, emit, buttonVariants, theme, currentVariant, clickEvent, AbButton }
}

})